/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import {
    IBuyboxAddToCartViewProps,
    IBuyboxAddToOrderTemplateViewProps,
    // IBuyboxAddToWishlistViewProps,
    IBuyboxCallbacks,
    IBuyboxData,
    IBuyboxFindInStoreViewProps,
    IBuyboxKeyInPriceViewProps,
    IBuyboxProductConfigureDropdownViewProps,
    IBuyboxProductConfigureViewProps,
    IBuyboxProductQuantityViewProps,
    IBuyboxProps,
    IBuyboxShopSimilarLookViewProps,
    IBuyboxState,
    IBuyboxViewProps,
    IBuyboxCommonData,
    IBuyboxExtentedProps
} from '@msdyn365-commerce-modules/buybox';
import {
    IncrementalQuantity,
    ITelemetryContent,
    Module,
    Node,
    // Button,
    // INodeProps,
    Modal,
    ModalBody,
    // ModalFooter,
    ModalHeader,
    Waiting
} from '@msdyn365-commerce-modules/utilities';
import { RichTextComponent } from '@msdyn365-commerce/core';
import * as React from 'react';
import { AttributeValue, ProductAvailableQuantity } from '@msdyn365-commerce/retail-proxy';
import {
    IBuyboxProps as IBuyboxExtentionProps,
    IBuyboxResources as IBuyboxExtentionResources
} from '../definition-extensions/buybox.ext.props.autogenerated';
import { getAttributeValuesAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';
import { generateImageUrl } from '@msdyn365-commerce-modules/retail-actions';
import { trafficLightsAtpaction, TrafficLightsAtpInput } from '../../../actions/traffic-lights-atp.action';
import { ATPMessage, TrafficLights } from '../../../utils/atp-utils';
import EstimatedShipDateComponent from '../../../utils/ATP/atpESD';
import { KitProduct } from '../../../utils/Kits/kits';
import { kRV_GetMultipleATPLeadTimeDateAsync } from '../../../actions/customProxy/ATP-update/DataActionExtension.g';
import {
    IKRV_ATPLeadTimePropertiesDate,
    IKRV_GetMultipleATPLeadTimeResponseDate
} from '../../../actions/customProxy/ATP-update/DataServiceEntities.g';
import EstimatedShipDateKitComponent from '../../../utils/ATP/atpKitESD';
import { PriceComponent } from './components/price.component';
import { filteredProductAttributeList, incExcPriceFormat, isRequestPrice, taxPercentage } from '../../../utils/helper';
import { PromotionBadges } from '../../../utils/badges';
const BuyboxView: React.FC<IBuyboxViewProps & IBuyboxExtentionProps<IBuyboxData> & ProductAvailableQuantity> = props => {
    const {
        ModuleProps,
        MediaGalleryContainerProps,
        ProductInfoContainerProps,
        addToCart,
        addToOrderTemplate,
        // addToWishlist,
        telemetryContent,
        configure,
        description,
        findInStore,
        quantity,
        // price,
        title,
        rating,
        callbacks,
        state,
        resources,
        inventoryLabel,
        shopSimilarLook,
        keyInPrice,
        quantityLimitsMessages,
        max,
        shopSimilarDescription,
        unitOfMeasure,
        productComparisonButton
    } = props;

    const Auth = props.context.request.user.isAuthenticated;
    const { minErrorMessage, maxErrorMessage, promotionalTextEnable, promotionalTextColor } = props.config;
    const { zeroPriceProductText } = props.resources;
    const {
        context: {
            actionContext,
            request: {
                apiSettings: { channelId, catalogId }
            }
        }
    } = props;

    const linkedProducts: any[] | undefined = props.data.product.result?.Components;
    const [producerName, setProducerName] = React.useState<string | undefined>('');
    const [producerKeyName, setProducerKeyName] = React.useState<string | undefined>('');
    const [manufacturerItemNumber, setManufacturerItemNumber] = React.useState<String | undefined>('');
    const [itemNumber, setItemNumber] = React.useState<String | undefined>('');
    const [isMax, setIsMax] = React.useState<boolean>(false);
    const [isMin, setIsMin] = React.useState<boolean>(true);
    const [isMaxPop, setIsMaxPop] = React.useState<boolean>(false);
    const [showMore, setShowMore] = React.useState<boolean>(false);
    const [isClassName, setIsClassName] = React.useState<boolean>(true);
    const [attributes, setAttributes] = React.useState<AttributeValue[]>();
    const [disountedWpPrice, setDiscountedwpPrice] = React.useState<String | undefined>('');
    const [productName, setProductName] = React.useState<String | undefined>('');
    const [promotionalText, setPromotionalText] = React.useState<String | undefined>('');
    const [importantNotice, setimportantNotice] = React.useState<String | undefined>('');
    const [longDescription, setlongDescription] = React.useState<String | undefined>('');
    const [disableAddToCartATP, setDisableAddToCartATP] = React.useState<boolean>(false);

    const extensionsProps = props.data.product.result?.ExtensionProperties;
    let promotionBadge = '';
    if (extensionsProps?.find(e => e?.Key === 'PromotionBadge')) {
        promotionBadge = extensionsProps?.find(e => e?.Key === 'PromotionBadge')?.Value?.StringValue || '';
    }
    // ************ VSI Customization Starts for Bundle kit ATP ****************//
    const [atpData, setAtpData] = React.useState<Array<IKRV_GetMultipleATPLeadTimeResponseDate | undefined>>([]);
    const [kitProductATP, setKitProductATP] = React.useState<boolean>(false);
    const [isKitProductATPDiscontinued, setIsKitProductATPDiscontinued] = React.useState<boolean>(false);
    const productAttributes = filteredProductAttributeList(attributes, props.context.app.config.kcProductAttribute);
    const findProducerName = () => {
        productAttributes?.map(e => {
            if (e.identifier === 'Manufacturer') {
                setProducerName(e?.TextValue);
            }
        });
    };
    const findProducerKeyName = () => {
        productAttributes?.map(e => {
            if (e.identifier === 'Manufacturer') {
                setProducerKeyName(e?.Name);
            }
        });
    };
    const globalProducerName = () => {
        let globalProducerName: string = '';
        productAttributes?.map(e => {
            if (e.identifier === 'Manufacturer') {
                const manufactuerValueforImage = e.ExtensionProperties?.find(eProperty => eProperty.Key === 'globalAttributeValue')?.Value;
                globalProducerName = manufactuerValueforImage?.StringValue || '';
            }
        });
        return globalProducerName;
    };

    const _atpData = async (products: any[] | undefined) => {
        const KRVATPLeadTimeDate: any[] = [];
        //Create date according to API
        const objectDate = new Date();
        const day = objectDate.getDate();
        const month = objectDate.getMonth();
        const year = objectDate.getFullYear();
        const requestedDate = `${day}/${month + 1}/${year}`;

        if (products && products.length > 0) {
            products?.map((e: any) => {
                KRVATPLeadTimeDate.push({
                    itemID: e.ItemId,
                    requestedDate: requestedDate
                });
            });
        }
        const ctx = { callerContext: props.context.actionContext };
        try {
            const response = await kRV_GetMultipleATPLeadTimeDateAsync(ctx, KRVATPLeadTimeDate);
            setAtpData([response] || []);
            setKitProductATP(true);
        } catch (err) {
            console.error(err, 'ERR');
        }
    };
    function kitProductATPCall() {
        if (linkedProducts?.length !== 0) {
            _atpData(linkedProducts);
        }
    }
    React.useEffect(() => {
        if (linkedProducts?.length !== 0 && Auth) {
            if (!kitProductATP) {
                kitProductATPCall();
            }
            const anyRed = atpData[0]?.ATPTrafficLights?.filter(item => item.TrafficLight === 'Red');
            if (anyRed?.length) {
                setIsKitProductATPDiscontinued(true);
            }
        }
    }, [linkedProducts, atpData]);
    // ************ VSI Customization Ends for Bundle kit ATP ****************//
    // ************ VSI Customization Start ATP ****************//

    const [isLoading, setIsLoading] = React.useState<boolean>(true);
    const [trafficLightsResponse, settrafficLightsResponse] = React.useState<IKRV_ATPLeadTimePropertiesDate>();
    const [propMax, setPropMax] = React.useState<number>(max!);

    const [maxESD, setMaxESD] = React.useState<number>(max!);

    //Create date according to API
    let objectDate = new Date();
    let day = objectDate.getDate();
    let month = objectDate.getMonth();
    let year = objectDate.getFullYear();
    let requestedDate = `${month + 1}/${day}/${year}`;

    //Call Traffic Light Data Action
    async function trafficLightsDataActionCall() {
        setIsLoading(true);
        const requestBody: any = {
            itemId: itemNumber!,
            requestedDate: requestedDate
        };
        try {
            const trafficLightsParams = new TrafficLightsAtpInput(requestBody.itemId, requestBody.requestedDate);
            const trafficLightsSlots = await trafficLightsAtpaction(trafficLightsParams, props.context.actionContext);
            settrafficLightsResponse(trafficLightsSlots);
        } catch (error) {
            props.telemetry.warning('error');
            props.telemetry.debug('Unable to get response for traffic lights slots');
        }
        setIsLoading(false);
    }

    //VSI Customization Start React.useEffect & Function of ATP calculation
    React.useEffect(() => {
        if (max) {
            setPropMax(max);
        }
    }, [max]);

    //Use this Effect for set max values of product in state according to status
    React.useEffect(() => {
        if (trafficLightsResponse) {
            if (trafficLightsResponse.StatusCode === '500') {
                setPropMax(trafficLightsResponse?.Quantity);
                setMaxESD(trafficLightsResponse?.Quantity);
            } else if (trafficLightsResponse.StatusCode === '501') {
                if (trafficLightsResponse.POQuantity > props.state.max!) {
                    setPropMax(props.state.max!);
                    setMaxESD(trafficLightsResponse.POQuantity!);
                } else {
                    setPropMax(trafficLightsResponse.POQuantity!);
                    setMaxESD(trafficLightsResponse.POQuantity!);
                }
            } else if (trafficLightsResponse.StatusCode === '502') {
                setPropMax(trafficLightsResponse?.Quantity);
                setMaxESD(trafficLightsResponse?.Quantity);
            } else if (trafficLightsResponse.StatusCode === '503') {
                if (trafficLightsResponse?.Quantity + trafficLightsResponse.POQuantity > props.state.max!) {
                    setPropMax(props.state.max!);
                    setMaxESD(trafficLightsResponse?.Quantity + trafficLightsResponse.POQuantity);
                } else {
                    setPropMax(trafficLightsResponse?.Quantity + trafficLightsResponse.POQuantity);
                    setMaxESD(trafficLightsResponse?.Quantity + trafficLightsResponse.POQuantity);
                }
            } else if (
                trafficLightsResponse.StatusCode === '204' &&
                trafficLightsResponse?.Message?.toLocaleLowerCase() === props.resources.noFurtherSuppliesText
            ) {
                //checking if already same product exist in cart
                let productOfInterestQuantity: number | undefined;
                props.data.cart.result?.cart.CartLines?.map(item => {
                    if (item.ItemId === itemNumber) {
                        productOfInterestQuantity = item.Quantity;
                    }
                    return undefined;
                });
                setPropMax(
                    productOfInterestQuantity !== undefined
                        ? trafficLightsResponse?.Quantity - productOfInterestQuantity!
                        : trafficLightsResponse?.Quantity
                );
                setMaxESD(trafficLightsResponse?.Quantity);
            } else {
                setPropMax(props.state.max!);
            }
        }
    }, [trafficLightsResponse]);
    React.useEffect(() => {
        if (props.data.cart.result?.cart.CartLines && trafficLightsResponse?.StatusCode === '204') {
            //checking if already same product exist in cart
            let productOfInterestQuantity: number | undefined;
            props.data.cart.result?.cart.CartLines?.map(item => {
                if (item.ItemId === itemNumber) {
                    productOfInterestQuantity = item.Quantity;
                }
                return undefined;
            });
            //condition to disable add to cart
            if (productOfInterestQuantity && productOfInterestQuantity >= trafficLightsResponse?.Quantity!) {
                setDisableAddToCartATP(true);
            }
        }
    }, [props.data.cart.result?.cart.CartLines, trafficLightsResponse, props.state]);

    React.useEffect(() => {
        if (requestedDate && itemNumber) trafficLightsDataActionCall();
    }, [requestedDate, itemNumber]);

    // ************ VSI Customization END ATP ****************//

    async function findAttributesValues() {
        const recordId: any = props.data.product.result?.RecordId;

        const attributes: AttributeValue[] = await getAttributeValuesAsync(
            { callerContext: actionContext, queryResultSettings: {} },
            recordId,
            channelId,
            catalogId
        );
        setAttributes(attributes);
    }

    React.useEffect(() => {
        findAttributesValues();
        setPromotionalTextFunction();
    }, []);

    React.useEffect(() => {
        state.quantity <= props.data.product.result?.Behavior?.MinimumQuantity! && state.quantity !== 1 ? setIsMin(true) : setIsMin(false);
        state.quantity < props.data.product.result?.Behavior?.MinimumQuantity! ? setIsClassName(true) : setIsClassName(false);
        state.quantity === propMax ? setIsMax(true) : setIsMax(false);
    }, [state.quantity]);

    React.useEffect(() => {
        if (isMaxPop !== true) {
            state.quantity === propMax ? setIsMaxPop(true) : setIsMaxPop(false);
        }
    }, [state.quantity]);

    React.useEffect(() => {
        if (attributes) {
            findProducerName();
            findProducerKeyName();
            findItemNumber();
            calculateWpPrice();
            findProductName();
            findManufacturerItemNumber();
            findImportantNotice();
            findlongDescription();
        }
    }, [attributes]);

    const findManufacturerItemNumber = () => {
        attributes?.map(e => {
            if (e.Name === 'Manufacturer item number') {
                setManufacturerItemNumber(e?.TextValue);
            }
        });
    };
    const findProductName = () => {
        const product = props.data.product?.result?.Name;
        setProductName(product);
    };
    const findItemNumber = () => {
        let itemId = props.data.product.result?.ItemId;

        setItemNumber(itemId);
    };
    const setPromotionalTextFunction = () => {
        if (props.data.product.result?.ExtensionProperties) {
            props.data.product.result?.ExtensionProperties?.map(e => {
                if (e.Key?.toLowerCase() === 'promotion') {
                    setPromotionalText(e?.Value?.StringValue!);
                }
            });
        }
    };

    const findImportantNotice = () => {
        let importantNotice = props.data.product.result?.ExtensionProperties;
        importantNotice?.map(e => {
            if (e.Key === 'ImportantNotice') {
                setimportantNotice(e.Value?.StringValue);
            }
        });
    };
    const findlongDescription = () => {
        let longDescription = props.data.product.result?.ExtensionProperties;
        longDescription?.map(e => {
            if (e.Key === 'LongDescription') {
                setlongDescription(e.Value?.StringValue);
            }
        });
    };
    const calculateWpPrice = () => {
        let basePrice = props.data.productPrice.result?.CustomerContextualPrice;
        let discountedPrice = props.data.productPrice.result?.CustomerContextualPrice;
        let tempBasePrice, tempDiscountedPrice, displayWpPrice;

        if (basePrice === discountedPrice) {
            attributes?.map(e => {
                if (e.Name === 'Power rating Pmax (Wp)') {
                    if (e.IntegerValue !== 0) {
                        tempBasePrice = basePrice! / e.IntegerValue!;
                    }
                }
                if (e.KeyName === 'DisplayWPPrice' || e.Name === 'Display WP Price') {
                    displayWpPrice = e.BooleanValue;
                }
            });

            if (displayWpPrice && tempBasePrice !== undefined) {
                setDiscountedwpPrice(tempBasePrice);
            }
        } else {
            attributes?.map(e => {
                if (e.Name === 'Power rating Pmax (Wp)') {
                    if (e.IntegerValue !== 0) {
                        tempBasePrice = basePrice! / e.IntegerValue!;
                        tempDiscountedPrice = discountedPrice! / e.IntegerValue!;
                    }
                }
                if (e.KeyName === 'DisplayWPPrice' || e.Name === 'Display WP Price') {
                    displayWpPrice = e.BooleanValue;
                }
            });

            if (displayWpPrice && tempBasePrice !== undefined && tempDiscountedPrice !== undefined) {
                setDiscountedwpPrice(tempDiscountedPrice);
            }
        }
    };

    const _renderQuantity = (
        quantityComponent: IBuyboxProductQuantityViewProps,
        callbacks: IBuyboxCallbacks,
        props: IBuyboxProps<IBuyboxData>,
        state: IBuyboxState,
        extentionResources: IBuyboxExtentionResources,
        quantityLimitsMessages: React.ReactNode,
        propMax: number | undefined,
        telemetryContent?: ITelemetryContent,
        max?: number
    ): JSX.Element => {
        const { ContainerProps, LabelContainerProps, heading, errors } = quantityComponent;
        const { quantity, min } = state;
        return (
            <Node {...ContainerProps}>
                <Node {...LabelContainerProps}>
                    {heading}
                    {errors}
                </Node>

                {min && (
                    <IncrementalQuantity
                        id='ms-buybox__product-quantity-input'
                        max={propMax}
                        currentCount={quantity}
                        onChange={onChangeHandler(callbacks)}
                        inputQuantityAriaLabel={resources.inputQuantityAriaLabel}
                        decrementButtonAriaLabel={extentionResources.decrementButtonAriaLabel}
                        incrementButtonAriaLabel={extentionResources.incrementButtonAriaLabel}
                        minQuantityText={extentionResources.minQuantityText}
                        maxQuantityText={extentionResources.maxQuantityText}
                        telemetryContent={telemetryContent}
                        disabled={
                            trafficLightsResponse?.IsDiscontinuedProduct === 'Yes' ||
                            trafficLightsResponse?.IsAddToCart === 'No' ||
                            disableAddToCartATP
                        }
                    />
                )}
                <div className='quantity_text_message'>
                    {min && isMin && (
                        <p className='ms-buybox__minmax_label_text'>
                            <span className='sr-only'>{resources.informationHeading}</span>
                            <i className='msi-InfoCircle' aria-hidden='true'></i>
                            {`${minErrorMessage} ${min}`}
                        </p>
                    )}
                    {(isMax || disableAddToCartATP) && !isMin && (
                        <p className='ms-buybox__minmax_label_text'>
                            <span className='sr-only'>{resources.informationHeading}</span>
                            <i className='msi-InfoCircle' aria-hidden='true'></i>
                            {disableAddToCartATP
                                ? resources.maxQuantityAlertMessage.replace('{Quantity}', String(trafficLightsResponse?.Quantity) || '')
                                : `${maxErrorMessage} ${propMax}`}
                        </p>
                    )}
                    {/* {_generateStockErrorMessage()} */}
                </div>
            </Node>
        );
    };

    const getText = (text: any, showMoreText: string) => {
        // For Text that is shorter than desired length
        if (text?.props?.children?.length <= 100) return text.props.children;

        if (text?.props?.children?.length > 100) {
            return (
                <>
                    <p>
                        {`${text?.props?.children?.slice(0, 120)}...... `}
                        <button className='load-text' onClick={() => setShowMore(true)}>
                            {showMoreText}
                        </button>
                    </p>
                </>
            );
        }
    };

    const [imgURI, setImgURL] = React.useState<string | undefined>();

    //To set the producer name
    React.useEffect(() => {
        const producerGlobalName: string = globalProducerName() || '';
        if (producerGlobalName) {
            setImgURL(producerGlobalName);
        }
    }, [producerName]);

    //to generate Image url after getting img url from api call
    React.useEffect(() => {
        if (imgURI) {
            let imageUrl = generateImageUrl(imgURI, props.context.actionContext.requestContext.apiSettings);
            imageUrl = imageUrl?.replace('=/', '=') || '';
            setImgURL(imageUrl);
        }
    }, [imgURI]);

    //use this function to render or display category image
    const _renderCategoryImg = (imgURI: string) => {
        return <img src={`${imgURI}.png`} alt='producer-images' className='_logo' />;
    };

    //use this function to render item number
    const _renderItemNumber = () => {
        return (
            <div className='item-number-container'>
                <span className='item-number-title'>{props.resources.itemNumberText}:</span>
                <span className='item-number'>{itemNumber}</span>
            </div>
        );
    };
    //use this function to render Manufacturer item number
    const _renderManufacturerItemNumber = () => {
        return (
            <div className='item-number-container'>
                <span className='item-number-title'>{props.resources.manufacturerItemNumberText}:</span>
                <span className='item-number'>{manufacturerItemNumber}</span>
            </div>
        );
    };
    //use this function to render Promotional Text
    const _renderPromotionalText = () => {
        return (
            <Node className='promotional-text-container'>
                <div className='promotional-text' style={{ color: promotionalTextColor }}>
                    <RichTextComponent text={promotionalText} />
                </div>
            </Node>
        );
    };

    const _renderlongDescriptionAndImportantNotice = () => {
        return (
            <Node className='product-long-description'>
                <h2>{resources.productInfoHeading}</h2>
                <div className='discription-inner-section'>
                    {importantNotice && (
                        <div className='important-notice'>
                            <RichTextComponent text={importantNotice} />
                        </div>
                    )}
                    {longDescription && (
                        <div className='long-description'>
                            <RichTextComponent text={longDescription} />
                        </div>
                    )}
                </div>
            </Node>
        );
    };

    React.useEffect(() => {
        _renderPrice();
    }, [disountedWpPrice]);

    //use this function to render price
    const _renderPrice = () => {
        const { productPrice, customerInformation } = props.data;
        const customClass = linkedProducts?.length !== 0 ? '-bundle' : null;
        const {
            context: {
                app: {
                    config: { enabledIncExPrices }
                }
            }
        } = props;
        const ppwPrice =
            props?.context?.actionContext?.requestContext?.apiSettings?.oun !== props.context.app.config.ounNumberForUsSite
                ? 'WP Price:'
                : 'PPW Price:';
        const customerTaxPercentage = taxPercentage(props.data.customerInformation?.result!);
        return (
            <div className={`price-container${customClass}`}>
                {Auth &&
                isRequestPrice(productPrice?.result!, customerInformation?.result?.LineDiscountGroup!, linkedProducts?.length !== 0) ? (
                    <div className='no-price-wrapper'>
                        <span className='label'>{props.resources.requestPriceText}</span>
                        <div className='tooltip-wrapper' tabIndex={0}>
                            <span className='tooltip-icon' />
                            <span className='tooltip-text tooltip-left'>{zeroPriceProductText}</span>
                        </div>
                    </div>
                ) : (
                    <>
                        {/* {Auth && price} */}
                        {Auth && getBuyboxProductPrice(props, props.state)}
                        {Auth && linkedProducts?.length !== 0 ? <p className='bundle-price-label'>{'For Bundle'}</p> : null}
                        {/* VSI Customization WP Base price show once we have no discount on product & Wp base price
                and Wp Discount price only shoes when we have discount on our product  */}
                        {Auth && disountedWpPrice && linkedProducts?.length === 0 && (
                            <div className='wp-price-container'>
                                <span className='_title'>{ppwPrice}</span>
                                <div className='_wp-price-container'>
                                    <span className='_discounted-wp-price'>
                                        {incExcPriceFormat(
                                            Number(disountedWpPrice),
                                            props.context,
                                            enabledIncExPrices,
                                            customerTaxPercentage,
                                            3
                                        )}
                                    </span>
                                </div>
                            </div>
                        )}
                    </>
                )}
            </div>
        );
    };

    const _renderAddToCart = (addToCart: IBuyboxAddToCartViewProps, propMax: number): JSX.Element => {
        const { errorBlock, button } = addToCart;
        let customAddBundleToCartButton;

        if (linkedProducts?.length !== 0) {
            customAddBundleToCartButton =
                button &&
                React.cloneElement(button as JSX.Element, {
                    title: 'Add Bundle to Cart',
                    children: 'Add Bundle to Cart',
                    addToCartText: 'Add Bundle to Cart',
                    className: 'add-bundle_cta'
                });
        }
        const customAddToCartButton =
            button &&
            React.cloneElement(button as JSX.Element, {
                isStatusTwoZeroFour: trafficLightsResponse?.StatusCode === '204' ? true : false
            });
        return (
            <div className='product-add-to-cart'>
                {errorBlock}
                <div className={`buttons sticky-button`}>
                    {linkedProducts?.length !== 0
                        ? Auth && (
                              <button className='msc-add-to-cart' disabled={true}>
                                  {props.resources.addBundleToCartText}
                              </button>
                          )
                        : isClassName ||
                          propMax === 0 ||
                          isRequestPrice(
                              props.data?.productPrice?.result!,
                              props.data.customerInformation.result?.LineDiscountGroup!,
                              linkedProducts?.length !== 0
                          ) ||
                          trafficLightsResponse?.TrafficLight === 'Red' ||
                          trafficLightsResponse?.IsAddToCart === 'No' ||
                          trafficLightsResponse?.IsDiscontinuedProduct === 'Yes' ||
                          disableAddToCartATP ||
                          isLoading
                        ? Auth && (
                              <button className='msc-add-to-cart' disabled={true}>
                                  {props.resources.addToCartText}
                              </button>
                          )
                        : Auth && linkedProducts?.length !== 0
                        ? isKitProductATPDiscontinued
                            ? Auth && (
                                  <button className='msc-add-to-cart' disabled={true}>
                                      {props.resources.addBundleToCartText}
                                  </button>
                              )
                            : customAddBundleToCartButton
                        : Auth && customAddToCartButton}
                    {Auth &&
                        addToOrderTemplate &&
                        !isRequestPrice(
                            props.data?.productPrice?.result!,
                            props.data.customerInformation.result?.LineDiscountGroup!,
                            linkedProducts?.length !== 0
                        ) &&
                        !isKitProductATPDiscontinued &&
                        trafficLightsResponse?.TrafficLight !== 'Red' &&
                        trafficLightsResponse?.IsAddToCart !== 'No' &&
                        !disableAddToCartATP &&
                        _renderAddToOrderTemplate(addToOrderTemplate)}
                </div>
            </div>
        );
    };

    // ***** VSI CUSTOMIZATION START AVAILABLE use this useState and useEffect for disable request price link untill all data available *****//
    const [isDisableLink, setIsDisableLink] = React.useState<boolean>(true);

    React.useEffect(() => {
        if (producerName && productName && itemNumber) {
            setIsDisableLink(false);
        }
    }, [producerName, productName, itemNumber]);

    // ***** VSI CUSTOMIZATION END *****//
    return (
        <>
            {isMaxPop && (
                <Modal
                    wrapClassName='ms-order-template-mobile-view-modal buybox-description-popup-container'
                    autoFocus
                    fade={false}
                    applicationNode='renderPage'
                    isOpen={true}
                    toggle={() => {
                        setIsMaxPop(false);
                    }}
                >
                    <div className='modal-body-container'>
                        <ModalHeader
                            toggle={() => {
                                setIsMaxPop(!setIsMaxPop);
                            }}
                        >
                            {props.resources.alertText}
                        </ModalHeader>
                        <ModalBody>
                            {props.resources.maxPurchaseAlertMessage
                                .replace('{productName}', producerName || '')
                                .replace('{propMax}', String(propMax) || '')}
                            {/* {state.quantity && state.quantity === propMax && state.quantity >= propMax!
                                ? _generateStockErrorMessage()
                                : ` 'Maximum purchase quantity of the artice ${productName} is limited to ${propMax} piece per order.`} */}
                        </ModalBody>
                    </div>
                </Modal>
            )}
            {showMore && (
                <Modal
                    wrapClassName='ms-order-template-mobile-view-modal buybox-description-popup-container'
                    autoFocus
                    tabIndex={0}
                    fade={false}
                    applicationNode='renderPage'
                    isOpen={true}
                    toggle={() => {
                        setShowMore(!showMore);
                    }}
                >
                    <div className='modal-body-container'>
                        <ModalHeader
                            toggle={() => {
                                setShowMore(!showMore);
                            }}
                        >
                            {props.resources.descriptionText}
                        </ModalHeader>
                        <ModalBody>{description}</ModalBody>
                    </div>
                </Modal>
            )}
            <Module {...ModuleProps}>
                <PromotionBadges context={props.context} promotionalBadge={promotionBadge} />
                <Node {...MediaGalleryContainerProps}>{props.mediaGallery}</Node>
                <Node {...ProductInfoContainerProps}>
                    <div className='_logo-container'>{imgURI && _renderCategoryImg(imgURI)}</div>
                    {title}
                    <div className='description'>{getText(description, props.resources.showMoreText)}</div>
                    <div className='item-number-wrapper'>
                        {itemNumber && _renderItemNumber()}
                        {manufacturerItemNumber && _renderManufacturerItemNumber()}
                    </div>
                    {promotionalText && promotionalTextEnable && _renderPromotionalText()}
                    {/* *********** VSI CUSTOMIZATION STARTS FOR Kit Bundles ************ */}
                    {linkedProducts?.length !== 0 && Auth ? (
                        <KitProduct linkedProducts={linkedProducts} props={props} />
                    ) : (
                        <>
                            {unitOfMeasure}
                            {props.bulkPurchaseLink}
                            {_renderTextBlock(props.slots.textBlocks)}
                            {/* {description} */}
                            {rating}
                            {configure && _renderConfigure(configure)}
                            {Auth ? keyInPrice && _renderKeyInPrice(keyInPrice) : false}
                        </>
                    )}
                    {/* *********** VSI CUSTOMIZATION START FOR ATP ************ */}
                    <div className={Auth ? 'atp-pdp-wrapper' : 'pdp-guest'}>
                        {Auth ? (
                            isLoading ? (
                                <Waiting />
                            ) : (
                                <div className='atp-pdp-container'>
                                    {trafficLightsResponse && (
                                        <>
                                            <div className='lights-section'>
                                                <TrafficLights
                                                    lightColor={
                                                        linkedProducts?.length !== 0
                                                            ? 'Yellow'
                                                            : isKitProductATPDiscontinued
                                                            ? 'Red'
                                                            : trafficLightsResponse?.TrafficLight
                                                    }
                                                    isVisible={trafficLightsResponse?.IsVisible}
                                                />
                                                {linkedProducts?.length !== 0 ? (
                                                    <div className='_message-container'>
                                                        <h4 className='_traffic-light-quantity'>{props.resources.callOfficeText} </h4>
                                                    </div>
                                                ) : isKitProductATPDiscontinued ? (
                                                    <div className='_message-container'>
                                                        <h4 className='_traffic-light-quantity'>
                                                            {props.resources.noFurtherSuppliesText}{' '}
                                                        </h4>
                                                    </div>
                                                ) : (
                                                    <ATPMessage
                                                        {...trafficLightsResponse}
                                                        locale={props.context.app.config.dateFormat}
                                                        currency={props.context.request.channel?.Currency}
                                                    />
                                                )}
                                            </div>
                                        </>
                                    )}
                                    {linkedProducts?.length !== 0 ? (
                                        <EstimatedShipDateKitComponent
                                            linkedProducts={linkedProducts}
                                            itemNumber={itemNumber}
                                            propMax={maxESD}
                                            context={props.context}
                                            trafficLightsResponse={trafficLightsResponse}
                                            anyChildWithRedLight={isKitProductATPDiscontinued}
                                        />
                                    ) : isKitProductATPDiscontinued ? null : (
                                        <EstimatedShipDateComponent
                                            itemNumber={itemNumber}
                                            propMax={maxESD}
                                            context={props.context}
                                            trafficLightsResponse={trafficLightsResponse}
                                        />
                                    )}
                                </div>
                            )
                        ) : (
                            false
                        )}
                    </div>
                    {/* *********** VSI CUSTOMIZATION End FOR ATP ************ */}
                    {/* *********** VSI CUSTOMIZATION END FOR Kit Bundles ************ */}
                    {inventoryLabel}
                    <div className='quantity-addtobag'>
                        <div className='action-container'>
                            {Auth ? (
                                linkedProducts?.length !== 0 ? (
                                    <div className='quantity'>
                                        <div className='ms-buybox__product-quantity-label'>{props.resources.quantityText}</div>
                                        <button className={`decrement quantity__controls disabled`} />
                                        <input type='number' className='quantity-input' value={1} disabled={true} />
                                        <button className={`increment quantity__controls disabled`} />
                                    </div>
                                ) : (
                                    quantity &&
                                    _renderQuantity(
                                        quantity,
                                        callbacks,
                                        props,
                                        state,
                                        resources,
                                        quantityLimitsMessages,
                                        propMax,
                                        telemetryContent,
                                        max
                                    )
                                )
                            ) : (
                                false
                            )}
                            {_renderPrice()}
                        </div>
                        {addToCart && _renderAddToCart(addToCart, propMax)}
                        {/* {Auth ? _renderCartAndActions(addToCart, addToOrderTemplate, addToWishlist) : false} */}
                        {!Auth ? (
                            <div className='request-price sticky-button'>
                                {props.config.requestPriceButton && props.config.requestPriceButton.linkText && <RichTextComponent />}
                                <a
                                    title='Request Price'
                                    className={`Request-Price-btn ${isDisableLink ? 'disable-link' : ''} ${
                                        itemNumber && productName ? '' : 'disabled'
                                    } `}
                                    aria-disabled={itemNumber ? false : true}
                                    href={`${props.config.requestPriceButton &&
                                        props.config.requestPriceButton.linkUrl
                                            .destinationUrl}?ItemId=${itemNumber}&Name=${productName}&producerKeyName=${producerKeyName}&producer=${producerName}`}
                                >
                                    {props.config.requestPriceButton?.linkText}
                                </a>
                            </div>
                        ) : (
                            false
                        )}
                    </div>
                    {findInStore && _renderFindInStore(findInStore)}
                    {_renderSocialShare(props.slots && props.slots.socialShare)}
                    {productComparisonButton}
                    {shopSimilarLook && _renderShopSimilarItem(shopSimilarLook)}
                    {shopSimilarDescription && _renderShopSimilarItem(shopSimilarDescription)}
                </Node>
            </Module>
            {(longDescription || importantNotice) && _renderlongDescriptionAndImportantNotice()}
        </>
    );
};

const _renderTextBlock = (textBlocks: React.ReactNode[]): JSX.Element | undefined => {
    if (!textBlocks || textBlocks.length === 0) {
        return undefined;
    }

    return <>{textBlocks[0]}</>;
};

const _renderAddToOrderTemplate = (addToOrderTemplate: IBuyboxAddToOrderTemplateViewProps): JSX.Element => {
    const { ContainerProps, errorBlock, button } = addToOrderTemplate;

    return (
        <Node {...ContainerProps}>
            {errorBlock}
            {button}
        </Node>
    );
};

const _renderSocialShare = (socialShare: React.ReactNode[]): JSX.Element | undefined => {
    if (!socialShare || socialShare.length === 0) {
        return undefined;
    }

    return <>{socialShare[0]}</>;
};
const _renderConfigure = (configure: IBuyboxProductConfigureViewProps): JSX.Element => {
    const { ContainerProps, dropdowns } = configure;

    return <Node {...ContainerProps}>{dropdowns.map(_renderConfigureDropdown)}</Node>;
};

const _renderConfigureDropdown = (dropdown: IBuyboxProductConfigureDropdownViewProps): JSX.Element => {
    const { ContainerProps, LabelContainerProps, heading, errors, select } = dropdown;

    return (
        <Node {...ContainerProps}>
            <Node {...LabelContainerProps}>
                {heading}
                {errors}
            </Node>
            {select}
        </Node>
    );
};

const _renderFindInStore = (findInStore: IBuyboxFindInStoreViewProps): JSX.Element => {
    const { ContainerProps, storeSelector, heading, description, errors, button, modal, productPickupOptionList } = findInStore;

    return (
        <Node {...ContainerProps}>
            {storeSelector}
            {heading}
            {productPickupOptionList}
            {description}
            {errors}
            {button}
            {modal}
        </Node>
    );
};

/**
 * On Change function.
 * @param callbacks -Callbacks.
 * @returns Update quantity.
 */
const onChangeHandler = (callbacks: IBuyboxCallbacks) => (newValue: number): boolean => {
    if (callbacks.updateQuantity) {
        return callbacks.updateQuantity(newValue);
    }
    return true;
};
const _renderKeyInPrice = (keyInPrice: IBuyboxKeyInPriceViewProps): JSX.Element => {
    const { ContainerProps, LabelContainerProps, heading, input } = keyInPrice;

    return (
        <Node {...ContainerProps}>
            <Node {...LabelContainerProps}>{heading}</Node>
            {input}
        </Node>
    );
};

const _renderShopSimilarItem = (shopSimilarItem: IBuyboxShopSimilarLookViewProps): JSX.Element => {
    const { ContainerProps, errors, input } = shopSimilarItem;

    return (
        <Node {...ContainerProps}>
            {errors}
            {input}
        </Node>
    );
};

const getBuyboxProductPrice = (props: IBuyboxExtentedProps<IBuyboxCommonData>, state: IBuyboxState): React.ReactElement | undefined => {
    const { id, typeName, context, resources } = props;
    const customerTaxPercentage = taxPercentage(props.data.customerInformation?.result!);

    return (
        state.productPrice && (
            <PriceComponent
                id={id}
                typeName={typeName}
                context={context}
                data={{ price: state.productPrice }}
                isPriceMinMaxEnabled={
                    props.data.featureState.result?.find(
                        featureState => featureState.Name === 'Dynamics.AX.Application.RetailSearchPriceRangeFeature'
                    )?.IsEnabled
                }
                isSalesAgreementPriceFeatureEnabled={
                    props.data.featureState.result?.find(
                        featureState => featureState.Name === 'Dynamics.AX.Application.RetailSalesAgreementPriceSupportFeature'
                    )?.IsEnabled
                }
                useLegacySalesAgreementHTMLFeature={
                    props.data.featureState.result?.find(featureState => featureState.Name === 'UseLegacySalesAgreementHTMLFeature')
                        ?.IsEnabled
                }
                priceResources={{
                    priceRangeSeparator: resources.priceRangeSeparator,
                    salesAgreementPricePrompt: resources.salesAgreementPricePrompt,
                    salesAgreementExpirationDatePrompt: resources.salesAgreementExpirationDatePrompt,
                    salesAgreementCommittedQuantityPrompt: resources.salesAgreementCommittedQuantityPrompt,
                    salesAgreementRemainingQuantityPrompt: resources.salesAgreementRemainingQuantityPrompt
                }}
                freePriceText={resources.priceFree}
                originalPriceText={resources.originalPriceText}
                currentPriceText={resources.currentPriceText}
                isIncExPriceFormatEnabled={true}
                customerTaxPercentage={customerTaxPercentage}
            />
        )
    );
};
export default BuyboxView;
